"use strict";
exports.__esModule = true;
exports.KEYS = {
    INIT: 'report:options.load',
    APPLY: 'report-options:apply',
    RESET: 'report-options:reset',
    CLEAR: 'report-options:clear',
    COMPARE_CLEAR: 'report-options:compare.clear',
    COMPARE_SET: 'report-options:compare.set',
    COLLAPSE: 'workbench:toggle-collapse:bottom',
    ADD_FILTER: 'report-options:addfilter',
    SET_DEFAULT: 'report-options:setDefault',
    SET_DEFAULT_AND_TREE_FILTER: 'report-options:setDefaultAndTreeFilter'
};
exports["default"] = exports.KEYS;
//# sourceMappingURL=broadcast-config.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/broadcast-config.js